import {companyData} from "../../global/change-company";
import {resources} from "../../../constants/string-resources";

const isCorporate = companyData.id == 1;
const pendingFilter = {
    filters: [],
    logic: 'or',
    forField: 'pendingApprovals'
};
const myCreatedFilter = {
    filters: [],
    logic: 'and',
    forField: 'originator'
};
const filterRoles = [];

let waiverGrid;
let extraFiltersInitialized = false;
let waiverGridInitialized = false;

const waiverModel = new kendo.data.Model.define({
    id: 'id',
    fields: {
        id: {
            type: 'number',
            editable: false
        },
        displayId: {
            type: 'string',
            editable: false
        },
        company: {
            type: 'string',
            editable: false
        },
        type: {
            type: 'string',
            editable: false
        },
        createdDate: {
            type: 'date',
            editable: false
        },
        requestedBy: {
            type: 'string',
            editable: false
        },
        jobName: {
            type: 'string',
            editable: false
        },
        status: {
            type: 'string',
            editable: false
        },
        branchManagerApproved: {
            type: 'boolean',
            editable: false
        },
        branchManagerApproval: {
            type: 'string',
            editable: false
        },
        svpApproved: {
            type: 'boolean',
            editable: false
        },
        svpApproval: {
            type: 'string',
            editable: false
        },
        cooApproved: {
            type: 'boolean',
            editable: false
        },
        cooApproval: {
            type: 'string',
            editable: false
        },
        cfoApproved: {
            type: 'boolean',
            editable: false
        },
        cfoApproval: {
            type: 'string',
            editable: false
        },
        ceoApproved: {
            type: 'boolean',
            editable: false
        },
        ceoApproval: {
            type: 'string',
            editable: false
        },
        rejected: {
            type: 'boolean',
            editable: false
        },
        rejection: {
            type: 'string',
            editable: false
        }
    }
});

const getApprovalTag = (isApproved, approval, title) => {
    const tagClass = isApproved ? 'tag--green' : 'tag--red';
    const tagText = isApproved ? approval : title;
    const tag = `<div class="tag tag--small-x ${tagClass}">${tagText}</div>`;
    return tag;
}

const requestStatusTemplate = (row) => {
    const tags = ['<div class="bond-waiver-approval-wrapper">'];

    row.Approvals.forEach(item => {
        tags.push(getApprovalTag(item.IsApproved, item.Approval, item.Title))
    });

    if (row.rejected) {
        const rejectionTag = `<div class="tag tag--small-x tag--blue">${row.rejection}</div>`;
        tags.push(rejectionTag);
    }

    tags.push('</div>');
    return tags.join('<br/>');
}

const waiverDatasource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Operations/BondWaiver/GetWaivers',
            dataType: 'json',
            data: {branchId: companyData.id}
        }
    },
    schema: {
        model: waiverModel,
        parse(r) {
            if (r.length <= 0) return;
            return r;
        }
    },
    pageSize: 20
});

const waiverColumns = [{
    field: 'company',
    title: 'Branch',
    hidden: !isCorporate
}, {
    field: 'displayId',
    title: 'Request #'
}, {
    field: 'createdDate',
    title: 'Created On',
    format: '{0:MM/dd/yyyy}'
}, {
    field: 'requestedBy',
    title: 'Requested By'
}, {
    field: 'type',
    title: 'Type'
}, {
    field: 'jobName',
    title: 'Job Name'
}, {
    field: 'status',
    title: 'Status',
    template: requestStatusTemplate
}];

const openWaiver = (e) => {
    const dre = $(e.target).closest('tr[role="row"]');
    const dr = waiverGrid.dataItem(dre);
    $.redirect({
        url: `/Operations/BondWaiver/RequestForm`,
        values: {
            RequestId: dr.id
        }
    });
};

const waiverGridDataBound = (e) => {
    const grid = e.sender;
    const rows = $(grid.element).find('table[role="grid"] tbody tr[role="row"]');
    rows.unbind('click');
    rows.on('click', openWaiver);
    rows.css('cursor', 'pointer');
};

const initGrid = () => {
    if (waiverGridInitialized === true) return;
    const gridEle = $('.js-bond-waiver-grid');
    gridEle.kendoGrid({
        // autoBind: false,
        autoBind: true,
        dataSource: waiverDatasource,
        columns: waiverColumns,
        dataBound: waiverGridDataBound,
        sortable: true,
        scrollable: true,
        filterable: {
            operators: {
                string: {
                    contains: 'Contains',
                    startswith: 'Starts with'
                },
                number: {
                    gte: 'Greater than or equal to',
                    lte: 'Less than or equal to',
                    lt: 'Less than',
                    gt: 'Greater than',
                    eq: 'Equal to'
                },
                date: {
                    lt: 'Before',
                    gt: 'After',
                    eq: 'On',
                    lte: 'Before or On',
                    gte: 'After or On'
                }
            }
        },
        pageable: {
            alwaysVisible: true,
            pageSizes: [5, 10, 25, 50, 'all'],
            buttonCount: 20
        },
        //toolbar: kendo.template(),
        noRecords: {
            template: 'No waivers to display.'
        }
    });
    waiverGrid = gridEle.data('kendoGrid');
    waiverGridInitialized = true;
};

const newBondWaiver = () => {
    $('.js-bond-waiver-new').bind('click', function () {
        $.redirect({
            url: '/Operations/BondWaiver/RequestForm',
            values: {
                RequestNumber: 0
            }
        });
    })
}

export default function () {
    initGrid();
    newBondWaiver();
}
